import formatTime from '@sdk/utils/dateFormat/formatTime';
import { AuthProvider } from '@sdk/authentication/AuthContext';
import { useTheme } from 'styled-components';

import { UserSettingsProvider } from '@web/settings/UserSettingsContext';
import { UserOrgSettingsProvider } from '@web/settings/UserOrgSettingsContext';
import ConfirmationStateModal from '@web/timeClock/ConfirmationStateModal/ConfirmationStateModal';
import CheckmarkInCircleIcon from '@web/assets/svg/UI/checkmark-in-circle.svg';

const ConfirmationStateModalAngular = ({
  isConfirmationStateVisible,
  onConfirmationClose,
  Authentication,
  title,
}) => {
  const { colors } = useTheme();

  return (
    <AuthProvider currentUser={Authentication.user}>
      <UserSettingsProvider settings={Authentication.user.settings}>
        <UserOrgSettingsProvider settings={Authentication.user.orgSettings}>
          <ConfirmationStateModal
            icon={
              <CheckmarkInCircleIcon
                height={60}
                width={60}
                color={colors.success}
                viewBox="0 0 64 64"
              />
            }
            title={title}
            subtitle={formatTime(new Date(), Authentication.user.settings.usTimeFormat)}
            isConfirmationStateVisible={isConfirmationStateVisible}
            onConfirmationClose={onConfirmationClose}
          />
        </UserOrgSettingsProvider>
      </UserSettingsProvider>
    </AuthProvider>
  );
};

export default {
  ReactComponent: ConfirmationStateModalAngular,
  dependencies: ['Authentication'],
  bindings: {
    isConfirmationStateVisible: '<',
    onConfirmationClose: '&',
    title: '<',
  },
};
